import { SxProps, Theme } from '@mui/material';

export const tableContainerStyle: SxProps<Theme> = {
  height: 'calc(100vh - 64px)',
  width: '98%',
  p: 1,
};

export const dataGridStyle: SxProps<Theme> = {
  border: '1px solid rgba(0, 0, 0, 0.12)',
  borderRadius: 1,
  fontSize: '1rem',
  rowGap: '8px',
  columnGap: '12px',
  '& .MuiDataGrid-cell': {
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    padding: '12px',
    borderColor: 'rgba(0, 0, 0, 0.08)',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  // Make sort state obvious: sortable-on-hover remains subtle, active sort stays prominent.
  '& .MuiDataGrid-iconButtonContainer': {
    visibility: 'visible',
    width: 'auto',
  },
  '& .MuiDataGrid-sortIcon': {
    opacity: 0,
    transition: 'opacity 120ms ease-in-out',
  },
  '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-sortIcon': {
    opacity: 0.45,
  },
  '& .MuiDataGrid-columnHeader--sorted': {
    backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0.08))',
  },
  '& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-sortIcon': {
    opacity: 1,
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '& .MuiDataGrid-row': {
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .project-title-cell p': {
    margin: 0,
    padding: 0,
  },
};
